import { eventBus, EVENTS } from './commons/EventBus.js';
import Utils from "./commons/utils.js";
const CENTER=4;
$(document).on('click','.cce-filter-day', (e)=>{
    Utils.showWaitingLoader();
  const date=new Date();
  let child=e.currentTarget;
  var i = 1;
  while( child.previousElementSibling != null ){
    child=child.previousElementSibling;
    i++;
  }
  console.log(i);
  if(i!=CENTER){
    date.setDate(date.getDate()-(CENTER-i));
  }

  let h = $('.cce-filters-hour').text().trim().substring(0,2);
  date.setHours(h);
  date.setMinutes(0);
  console.log(date);
  const time=Math.round(date.getTime()/1000);
  replaceNavigation(`/musica/che-canzone-era/${time}`);
});
eventBus.on( EVENTS.PAGE_AFTER_RENDERING, function(data) {
  if(data.template != "che_canzone_era"){
    return;
  }

    setSelectedDay();
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    today = dd + '/' + mm + '/' + yyyy;

    $('input[name="cce_date"]').daterangepicker({
        singleDatePicker: true,
        showDropdowns: true,
        opens: 'center',
        maxDate: today,
        startDate: setSelectedDay(),
        "locale": Utils.SETTINGS.DATERANGEPICKER
    }, function(start, end, label) {
    });

    $('input[name="cce_date"]').on('apply.daterangepicker', function (ev, picker) {
        Utils.showWaitingLoader();
        let dateString=picker.startDate.format('MM/DD/YYYY');
        $("#insert_data_selected").text(picker.startDate.format('DD/MM/YYYY'));
        var day_to_go = new Date(dateString);
        day_to_go.setDate(day_to_go.getDate());
        selectHours($(".cce-filters-hour"), day_to_go);
    });

    $('input[name="cce_date"]').on('cancel.daterangepicker', function(ev, picker) {
        $("#insert_data_selected").text("DATA");

    });
    $(".cce-filters-date").on('click', () => {
        $(".cce_select_day").trigger("click");
    });


  if(window.mainPlayer.playing()){
    onPlay();
  }
  window.mainPlayer.on('resume', onPlay);

  window.mainPlayer.on('pause', () => {
    const playingClass = 'palinsesto-musica-playing';
    $('.actions-programma .palinsesto-musica-play').removeClass(playingClass);
  });


  $(".filter_option").on('click', function() {
      Utils.showWaitingLoader();
      $(".cce-filters-hour").text($(this).text());
      var data_val = "";
      if($("#insert_data_selected").text() != "DATA"){

          var dateString=$('input[name="cce_date"]').val().split("/").reverse().join("/");;
          var data_val = new Date(dateString);
          data_val.setDate(data_val.getDate());

      } else{

          let child=$(".cce-filter-day-selected");
          var i = 1;
          while( child.prev(".cce-filter-day ").length != 0 ){
              child=child.prev(".cce-filter-day ");
              i++;
          }

          if(i!=CENTER){
              var data_val = new Date();
              data_val.setDate(data_val.getDate()-(CENTER-i));
          }
      }
      selectHours(this, data_val);
  });

  $(".cce_filter_hour_cont").on('click', function() {
     $(".select_orario_cce").slideToggle();
  });

});
function onPlay() {
  console.log('onplay');

  const playingClass = 'palinsesto-musica-playing';
  $('.actions-programma .palinsesto-musica-play').addClass(playingClass);
}

function setSelectedDay(){
  const lastPathPart=window.location.href.split('/').reverse()[0];
  const toNum=Number(lastPathPart);

    $('.cce-filter-day').removeClass('cce-filter-day-selected');
  if(lastPathPart && !isNaN(toNum)){
    const date = new Date(toNum*1000);
    for (let i = 0; i <= 3; i++) {
      const compDay=new Date();
      compDay.setDate(compDay.getDate()-i);
      console.log(date, compDay);

      if(compDay.getDate() == date.getDate() && compDay.getMonth()==date.getMonth()){

        let child=4-i;
        console.log('child: '+child, 'i: '+i);
          $(`.cce-filter-day:nth-child(${child})`).addClass('cce-filter-day-selected');
        break;
      }
    }

    // if($(".cce-filter-day-selected").length == 0){
        let formatted_date = pad(date.getDate()) + "/" + pad(date.getMonth() + 1) + "/" + date.getFullYear()
        $("#insert_data_selected").text( formatted_date);
        return formatted_date;
    // }
  }else{
      $(`.cce-filter-day:nth-child(4)`).addClass('cce-filter-day-selected');
  }
}
function selectHours(me, day_to_go){
    if(!day_to_go){
    var date=new Date();
    } else{
        date = day_to_go;
    }
    let h = $(me).text().trim().substring(0,2);
    date.setHours(h);
    date.setMinutes(0);
    console.log(date);
    const time=Math.round(date.getTime()/1000);

    replaceNavigation(`/musica/che-canzone-era/${time}`);
}

function pad(n) {
    return n < 10 ? '0' + n : n
}
